<template>
  <div class="page">
    <div class="login_page">
      <div class="content-top"></div>
      <div class="content-bottom"></div>
      <div class="content-center">
        <div class="content-left">
          <div class="left-img"></div>
        </div>
        <div class="content-right">
          <div class="scan_con">
            <div class="desc">请使用"有道智慧学习app"扫码登录</div>
            <div class="desc-tip">登录账号需与有道硬件登录账号保持一致</div>
            <div class="app_scan_code">
              <div class="scan_success" v-if="isScanSuccess">扫描成功</div>
              <img class="qrcode" :src="qrCode" v-if="!isTokenTimeOut" alt="" />
              <div class="qrcode_timeout" v-else @click="refreshCode">
                <div class="refresh"></div>
                <div class="qrcode_timeout-notice">重新加载二维码</div>
              </div>
            </div>
            <div class="gap-content"></div>
            <div class="noapp-tip">还没有此APP？去下载</div>
            <div class="down">
              <div class="show-download-bg" v-if="showDwonloadQr"></div>
              <div class="showDwonloadQr" v-if="showDwonloadQr"></div>
              <div class="download-btn" @mouseenter="enters" @mouseleave="leaver">下载APP</div>
            </div>
            <div class="agreement-tip">登录即代表您已阅读并同意</div>
            <div class="agreement-tip agreement-tip-a">
              <a
                class="agreement_notice"
                target="_black"
                href="https://c.youdao.com/dict/hardware/law/intelligent_learning_terms_service.html"
                >《服务条款》</a
              >
              和<a
                class="agreement_notice"
                target="_black"
                href="https://c.youdao.com/dict/hardware/law/smart_learning_privacy.html"
                >《隐私政策》</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { message } from 'ant-design-vue';
import { useRouter } from 'vue-router';
// import routeController from '@/controller/router'
import accountService from '../../services/account';

export default {
  name: 'login',
  setup() {
    const { push } = useRouter();
    const store = useStore();
    const qrCode = ref('');
    const qrToken = ref('');
    const showDwonloadQr = ref(false);
    const isTokenTimeOut = ref(false);
    let loginstatTimer = null;
    let countTokenTimer = null;
    const isScanSuccess = ref(false);
    // 2分钟后登陆二维码过期重置数据
    const resetQrInfos = () => {
      qrToken.value = '';
      isTokenTimeOut.value = true;
      if (loginstatTimer) {
        // clearInterval(loginstatTimer)
        // loginstatTimer = null
      }
    };
    // 轮询登陆是否成功
    const getlLoginstat = () => {
      loginstatTimer = setInterval(() => {
        accountService
          .loginstat({
            token: qrToken.value,
          })
          .then(res => {
            const { code, msg } = res;
            if (code === 0) {
              clearInterval(loginstatTimer);
              loginstatTimer = null;
              if (countTokenTimer) {
                clearTimeout(countTokenTimer);
                countTokenTimer = null;
              }
              store.dispatch('getUserInfo');
              isScanSuccess.value = true;
              // message.success({ content: '登录成功' })
              setTimeout(() => {
                push({ path: '/' });
                window._rlog.push(['_trackEvent', 'login_app_click']);
              }, 1000);
            } else {
              console.log('loginstat error code=', code, msg);
            }
          })
          .catch(e => {
            console.log('loginstat error=', e);
          });
      }, 600);
    };
    // token 过期计时
    const countTokenTimeout = () => {
      if (countTokenTimer) {
        clearTimeout(countTokenTimer);
        countTokenTimer = null;
      }
      // token 有效期2分钟
      countTokenTimer = setTimeout(() => {
        resetQrInfos();
      }, 2 * 60 * 1000);
    };
    // 获取登陆二维码
    const getQrCode = () => {
      const hideLoading = message.loading({ content: 'loading', duration: 0 });
      accountService
        .loginqrcode()
        .then((res = {}) => {
          hideLoading();
          const { code, data } = res;
          if (code === 0) {
            const { qrcode, token } = data;
            qrCode.value = qrcode;
            qrToken.value = token;
            isTokenTimeOut.value = false;
            countTokenTimeout();
            getlLoginstat(); // 轮询登陆是否成功
          } else {
            resetQrInfos();
          }
        })
        .catch(() => {
          resetQrInfos();
        });
    };
    onMounted(() => {
      getQrCode();
    });
    const scanLogin = () => {
      getQrCode();
    };
    // 刷新登陆二维码
    const refreshCode = () => {
      resetQrInfos();
      getQrCode();
    };
    function leaver() {
      showDwonloadQr.value = false;
    }
    function enters() {
      window._rlog.push(['_trackEvent', 'login_app_click']);
      showDwonloadQr.value = true;
    }
    return {
      showDwonloadQr,
      leaver,
      enters,
      scanLogin,
      qrCode,
      qrToken,
      isTokenTimeOut,
      isScanSuccess,
      refreshCode,
    };
  },
};
</script>
<style lang="scss" scoped>
.page {
  overflow: auto;
  height: 100%;
  background: #f5f6f8;
}
.login_page {
  overflow: auto;
  margin: 0 auto;
  height: 100%;
  .down {
    position: relative;
    width: 160px;
    height: 40px;
    margin: 20px auto 34px;
  }
  .showDwonloadQr {
    bottom: 0;
    left: 50%;
    margin-left: -125px;
    width: 250px;
    height: 250px;
    position: absolute;
    background: url('./imgs/down-qrcode.png') center center no-repeat;
    background-size: 100% 100%;
    z-index: 3;
  }
  .show-download-bg {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(245, 246, 248, 0.7);
    z-index: 1;
  }
  .content-right {
    width: 400px;
    height: 560px;
    background: #ffffff;
    box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 40px 0;
    box-sizing: border-box;
    text-align: center;
    .app_scan_code {
      position: relative;
      width: 250px;
      height: 250px;
      margin: 0 auto;
      .qrcode {
        width: 100%;
        height: 100%;
      }
      .scan_success {
        position: absolute;
        width: 196px;
        height: 60px;
        right: 26px;
        bottom: 27px;
        background: #09cd58;
        opacity: 0.98;
        font-size: 15px;
        line-height: 60px;
        color: #ffffff;
        border-radius: 10px 10px 0 0;
      }
      .qrcode_timeout {
        padding: 84px 0 10px;
        .refresh {
          width: 64px;
          height: 64px;
          background-color: #fff;
          border-radius: 50%;
          margin: 0 auto;
          background: url('./imgs/refresh.png') center center no-repeat;
          background-size: 100% 100%;
        }
        .qrcode_timeout-notice {
          font-size: 15px;
          line-height: 18px;
          text-align: center;
          color: #212327;
        }
      }
    }
    .desc {
      font-weight: bold;
      font-size: 19px;
      line-height: 22px;
      color: #212327;
      margin-bottom: 4px;
    }
    .desc-tip {
      font-size: 14px;
      line-height: 16px;
      color: #898a8e;
    }
    .gap-content {
      width: 400px;
      height: 14px;
      background: url('./imgs/or.png') center center no-repeat;
      background-size: 100% 100%;
      margin: 0 0 30px;
    }
    .noapp-tip {
      font-size: 13px;
      line-height: 15px;
      text-align: center;
      color: #898a8e;
    }
    .download-btn {
      background: #ff333a;
      cursor: pointer;
      color: #fff;
      width: 160px;
      height: 40px;
      line-height: 40px;
      border-radius: 8px;
      position: absolute;
      left: 50%;
      margin-left: -80px;
      top: 0;
      z-index: 3;
    }
    .agreement-tip-a {
      display: flex;
      justify-content: center;
    }
    .agreement-tip {
      font-size: 13px;
      line-height: 15px;
      color: #898a8e;
    }
    .agreement_notice {
      font-size: 13px;
      line-height: 15px;
      color: #ff333a;
      height: 15px;
      cursor: pointer;
      white-space: nowrap;
    }
  }
  .content-top {
    position: absolute;
    top: 0;
    right: 99px;
    width: 640px;
    height: 320px;
    background: url('./imgs/bg-top.png') center center no-repeat;
    background-size: 100% 100%;
  }
  .content-bottom {
    position: absolute;
    top: auto;
    bottom: 0;
    width: 360px;
    height: 180px;
    left: 50%;
    transform: translate(-50%, 0);
    background: url('./imgs/bg-bottom.png') center center no-repeat;
    background-size: 100% 100%;
  }
  .content-center {
    width: 960px;
    height: 560px;
    position: absolute;
    left: 50%;
    top: 50%;
    display: flex;
    transform: translate(-50%, -50%);
    .content-left {
      width: 560px;
      box-sizing: border-box;
      padding-left: 80px;
      .tip {
        margin: 30px 0 43px;
        font-weight: 500;
        font-size: 17px;
        line-height: 20px;
        color: #898a8e;
      }
      .left-img {
        height: 560px;
        width: 400px;
        background: url('./imgs/left-img.png') center center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
